<template>
    <div class="row">
        <!-- Prevetting Timestamps Column -->
        <div v-if="hasPrevettingTimestamps" class="col">
            <p v-if="prevettingSubmittedAt" class="mb-0 font-weight-bold">Pre-Submitted:</p>
            <p v-if="prevettingSubmittedAt" class="mb-0">{{ prevettingSubmittedAt | fixFullDateLocal }}</p>
            
            <p v-if="!prevettingApprovedAt && prevettingRejectedAt" class="mb-0 font-weight-bold">Pre-Rejected:</p>
            <p v-if="!prevettingApprovedAt && prevettingRejectedAt" class="mb-0">{{ prevettingRejectedAt | fixFullDateLocal }}</p>
            
            <p v-if="prevettingApprovedAt" class="mb-0 font-weight-bold">Pre-Approved:</p>
            <p v-if="prevettingApprovedAt" class="mb-0">{{ prevettingApprovedAt | fixFullDateLocal }}</p>
        </div>

        <!-- Regular Timestamps Column -->
        <div class="col">
            <p v-if="submittedAt" class="mb-0 font-weight-bold">Submitted:</p>
            <p v-if="submittedAt" class="mb-0">{{ submittedAt | fixFullDateLocal }}</p>

            <p v-if="resubmittedAt" class="mb-0 font-weight-bold">Resubmitted:</p>
            <p v-if="resubmittedAt" class="mb-0">{{ resubmittedAt | fixFullDateLocal }}</p>
            
            <p v-if="!approvedAt && rejectedAt" class="mb-0 font-weight-bold">Rejected:</p>
            <p v-if="!approvedAt && rejectedAt" class="mb-0">{{ rejectedAt | fixFullDateLocal }}</p>

            <p v-if="suspendedAt" class="mb-0 font-weight-bold">Suspended:</p>
            <p v-if="suspendedAt" class="mb-0">{{ suspendedAt | fixFullDateLocal }}</p>

            <p v-if="expiredAt" class="mb-0 font-weight-bold">Expired:</p>
            <p v-if="expiredAt" class="mb-0">{{ expiredAt | fixFullDateLocal }}</p>
            
            <p v-if="approvedAt" class="mb-0 font-weight-bold">Approved:</p>
            <p v-if="approvedAt" class="mb-0">{{ approvedAt | fixFullDateLocal }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TimestampsColumn',
    props: {
        row: {
            type: Object,
            required: true
        },
    },
    computed: {
        hasPrevettingTimestamps() {
            /**
             * NOTICE FOR PREVETTING:
             * We are not using prevetting timestamps for now.  
             */
            return false
        },
        // Prevetting timestamps
        prevettingSubmittedAt() {
            return this.row.prevetting_submitted_at
        },
        prevettingApprovedAt() {
            return this.row.prevetting_approved_at
        },
        prevettingRejectedAt() {
            return this.row.prevetting_rejected_at
        },
        submittedAt() {
            return this.row.submitted_at
        },
        resubmittedAt() {
            return this.row.resubmitted_at
        },
        approvedAt() {
            return this.row.approved_at
        },
        rejectedAt() {
            return this.row.rejected_at
        },
        suspendedAt() {
            return this.row.suspended_at
        },
        expiredAt() {
            return this.row.expired_at
        },
    }
}
</script>
